import React, { useMemo } from 'react';
import { isDiscoModeEnabled, setDiscoMode } from 'ducks/layout';
import { useSelector } from 'react-redux';
import SceneAction from '../SceneAction';
import { useAppDispatch } from 'ducks/hooks';
import { useCore } from 'contexts/core';
import { NightLightsSystem } from '@inter-ikea-storageone/range';
import audioSource from './sounds/disco.mp3';
import { ComponentIds } from '@inter-ikea-core/core';
import { DiscoIcon } from '../icons/DiscoIcon';

const DiscoAction = (props: React.PropsWithoutRef<JSX.IntrinsicElements['button']>) => {
  const active = useSelector(isDiscoModeEnabled);
  const dispatch = useAppDispatch();
  const audio = useMemo(() => new Audio(audioSource), []);
  audio.loop = true;
  const coreApi = useCore();
  const lightsInScene = coreApi.entities.getByComponent(ComponentIds.LIGHT_COMPONENT_ID);

  return lightsInScene.length > 0 ? (
    <SceneAction
      {...props}
      label="Disco"
      data-testid="disco-toggle"
      aria-selected={active}
      onClick={() => {
        if (active) {
          dispatch(setDiscoMode(false));
          coreApi.getSystem<NightLightsSystem>('NightLightsSystem')?.disableDiscoMode();
          audio.pause();
        } else {
          dispatch(setDiscoMode(true));
          coreApi.getSystem<NightLightsSystem>('NightLightsSystem')?.enableDiscoMode();
          audio.play();
        }
      }}
      ssrIcon={DiscoIcon}
      enabled={active}
    />
  ) : (
    <></>
  );
};

export default DiscoAction;
